import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../../css/resetpassword.css";
import { resetPassword } from "../../services/authService";

const ResetPasswordPage = () => {
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const uid = searchParams.get("uid");
  const token = searchParams.get("token");
  const role = searchParams.get("role"); // get role from query params

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {

      console.log(uid);
      console.log(token);
      console.log(role);
      await resetPassword({
        uid,         // UID from the link
        token,       // Token from the link
        role,        // Role from query
        new_password: newPassword, // User entered password
      });

      toast.success("Password reset successful! You can now log in.");
      navigate("/login");
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to reset password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-password-container">
      <form onSubmit={handleSubmit} className="reset-password-form">
        <h2>Reset Password</h2>

        <div className="form-group">
          <label>New Password</label>
          <input
            type="password"
            required
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </div>

        <button type="submit" disabled={loading}>
          {loading ? "Resetting..." : "Reset Password"}
        </button>
      </form>
    </div>
  );
};

export default ResetPasswordPage;
